"use client";

import React, { useEffect } from "react";

import { Comedian } from "@/data/comedians";
import { SpecialRow } from "@/data/specials";
import { UserEvents } from "@/analytics/mixpanel/mixpanel.types";
import { trackEvent } from "@/analytics/mixpanel";
import { useSearchParams } from "next/navigation";

const LandingPageTracker: React.FC<{
  comedian: Pick<
    Comedian,
    "id" | "slug" | "display_name" | "display_name_short" | "about_img"
  >;
  special: SpecialRow;
}> = ({ comedian, special }) => {
  const searchParams = useSearchParams();

  useEffect(() => {
    if (comedian.id && special.id) {
      // Create an object to store all URL parameters
      const urlParams: Record<string, string> = {};

      // Add all search params to the urlParams object
      searchParams.forEach((value, key) => {
        urlParams[key] = value;
      });

      trackEvent(UserEvents.LOADED_CONTENT_PAGE, {
        ComedianId: comedian.id,
        SpecialId: special.id,
        Comedian: comedian.display_name,
        "Special Title": special.title,
        url_params: urlParams, // Include URL parameters as a nested object
      });
    }
  }, [
    comedian.display_name,
    comedian.id,
    special.id,
    special.title,
    searchParams,
  ]);

  return <></>;
};

export default LandingPageTracker;
